import * as tslib_1 from "tslib";
// angular imports
import { Exclude, Type } from 'class-transformer';
// cc-common imports
import { Utils } from 'cc-common';
// model imports
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
// constant imports
import { BoardApprovalProcessConstants } from '../_constants/board-approval-process-constants';
const ɵ0 = () => UserNameDisplayResultDto, ɵ1 = () => Date, ɵ2 = () => Date;
export class BoardApprovalItemResultDto {
    get hasNotesDisplayText() {
        return Utils.isTrue(this.hasNotes) ? 'Yes' : 'No';
    }
    get requiredDisplayText() {
        return Utils.isTrue(this.required) ? 'Yes' : 'No';
    }
    get userNameDisplayText() {
        return Utils.notNullAndDefined(this.userInfo) ? this.userInfo.displayName : null;
    }
    get detailDisplayText() {
        let title = null;
        switch (this.process) {
            case BoardApprovalProcessConstants.ACC:
                title = 'ACC';
                break;
            case BoardApprovalProcessConstants.COLLECTIONS:
                title = 'AR Collections';
                break;
            case BoardApprovalProcessConstants.WF:
                title = 'AP Workflow';
                break;
        }
        return `View ${title} Details`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], BoardApprovalItemResultDto.prototype, "userInfo", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], BoardApprovalItemResultDto.prototype, "addedOn", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], BoardApprovalItemResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], BoardApprovalItemResultDto.prototype, "allowSelection", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], BoardApprovalItemResultDto.prototype, "processDisplayText", void 0);
export { ɵ0, ɵ1, ɵ2 };
